import { MouseEventHandler } from "react";

export const Skeleton = ({ onChange }: { onChange: MouseEventHandler }) => (
  <div
    className="flex justify-center items-center cursor-pointer h-96 bg-[rgba(0,0,0,.1)]"
    onClick={onChange}
  >
    Karte aktivieren
  </div>
);
